import React from "react";
import DefaultLayout from "../../components/layout/DefaultLayout";
import {useSelector} from "react-redux";
import Grid from "@mui/material/Grid";
import VerticalTabs from "../../components/layout/tabs/VerticalTabs";
import PersonnalDataEditForm from "../../components/extranet/user/form/PersonnalDataEditForm";
import EmailEditForm from "../../components/extranet/user/form/EmailEditForm";
import PasswordEditForm from "../../components/extranet/user/form/PasswordEditForm";
import {AccountBox as AccountBoxIcon, Mail as MailIcon, VpnKey as VpnKeyIcon} from "@mui/icons-material";


const UserAccountParametersPage = (props) => {

    const account = useSelector(state => state.account);
    const [editMode , setEditMode] = React.useState(false);
    const [valueTab, setValueTab] = React.useState(0);

    return <DefaultLayout>
        <Grid spacing={2} container>
            <Grid xs={12} item>
                <VerticalTabs value={valueTab}
                              setValue={setValueTab}
                              elements={{
                                  "Données personnelles" : {
                                      'component': <PersonnalDataEditForm account={account}
                                                                          editMode={editMode}
                                                                          setEditMode={setEditMode}
                                      />,
                                      'icon': <AccountBoxIcon />
                                  },
                                  "Adresse e-mail": {
                                      'component': <EmailEditForm account={account} />,
                                      'icon': <MailIcon />
                                  },
                                  "Mot de passe": {
                                      'component': <PasswordEditForm account={account} />,
                                      'icon': <VpnKeyIcon />
                                  }
                              }}
                />
            </Grid>
        </Grid>
    </DefaultLayout>
}


export default UserAccountParametersPage;
